const SET_EMAIL_ACCOUNTS = (state, emailAccounts) => {
  state.emailAccounts = emailAccounts;
};

const SET_FETCHING_EMAIL_ACCOUNTS = (state, value) => {
  state.fetchingEmailAccounts = value;
};

const SET_EMAIL_ACCOUNTS_BY_USER = (state, emailAccounts) => {
  state.emailAccountsByUser = emailAccounts;
};

const SET_FETCHING_EMAIL_ACCOUNTS_BY_USER = (state, value) => {
  state.fetchingEmailAccountsByUser = value;
};

const SET_FETCHING_EMAIL_ACCOUNT_IDS = (state, emailAccountIds) => {
  // Add the emailAccountIds to the fetchingEmailAccountsIds array which don't
  // already exist in the array
  emailAccountIds.forEach((emailAccountId) => {
    if (state.fetchingEmailAccountsIds.indexOf(emailAccountId) === -1) {
      state.fetchingEmailAccountsIds.push(emailAccountId);
    }
  });
};

const UNSET_FETCHING_EMAIL_ACCOUNT_IDS = (state, emailAccountIds) => {
  // Unset the emailAccountIds from the fetchingEmailAccountsIds array
  emailAccountIds.forEach((emailAccountId) => {
    const index = state.fetchingEmailAccountsIds.indexOf(emailAccountId);

    if (index !== -1) {
      state.fetchingEmailAccountsIds.splice(index, 1);
    }
  });
};

const CACHE_EMAIL_ACCOUNT = (state, emailAccount) => {
  const index = state.emailAccountsCache.findIndex((ea) => ea.id === emailAccount.id);

  if (index !== -1) {
    state.emailAccountsCache.splice(index, 1);
  }

  state.emailAccountsCache.push(emailAccount);
};

export default {
  SET_EMAIL_ACCOUNTS,
  SET_FETCHING_EMAIL_ACCOUNTS,
  SET_EMAIL_ACCOUNTS_BY_USER,
  SET_FETCHING_EMAIL_ACCOUNTS_BY_USER,
  SET_FETCHING_EMAIL_ACCOUNT_IDS,
  UNSET_FETCHING_EMAIL_ACCOUNT_IDS,
  CACHE_EMAIL_ACCOUNT,
};
